import { EMPTY_OBJECT } from "lib";

import { getSaleStatuses } from "./root";

export const getSaleStatusById = saleStatusId => state =>
  getSaleStatuses(state)[saleStatusId] || EMPTY_OBJECT;
